import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Clock, Calendar, Target } from 'lucide-react';
export function Summer2026() {
  return <div className="w-full" data-id="element-825">
      <Hero data-id="element-826" />
      <LocationBanner data-id="element-827" />
      <IntroSection data-id="element-828" />
      <ProgramsAndSchedule data-id="element-829" />
      <WeekAtAGlance data-id="element-830" />
      <PeriodizedProgramming data-id="element-831" />
      <TestingAndRecovery data-id="element-832" />
      <MembershipIncludes data-id="element-833" />
      <FinalCta data-id="element-834" />
    </div>;
}
/* ---------- HERO ---------- */
function Hero() {
  return <section className="relative bg-reach-black overflow-hidden py-20 md:py-28" data-id="element-835">
      <div className="absolute inset-0 z-0" data-id="element-836">
        <img src="https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=2400&auto=format&fit=crop" alt="Athletes training on indoor turf" className="w-full h-full object-cover grayscale contrast-125 opacity-60" data-id="element-837" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/70 to-black/90" data-id="element-838" />
        <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-839" />
      </div>

      <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden" data-id="element-840">
        <div className="absolute top-1/3 -left-40 w-[55%] h-2 bg-reach-red transform -rotate-[7deg] opacity-50" data-id="element-841" />
        <div className="absolute top-[44%] -left-40 w-[40%] h-2 bg-reach-red transform -rotate-[7deg] opacity-30" data-id="element-842" />
        <div className="absolute top-[55%] -left-40 w-[28%] h-2 bg-reach-red transform -rotate-[7deg] opacity-20" data-id="element-843" />
      </div>

      <div className="relative z-20 max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-844">
        <p className="font-inter text-reach-red text-xs md:text-sm uppercase tracking-[0.3em] font-semibold mb-5" data-id="element-845">
          Summer Season . June 1 to August 8
        </p>
        <h1 className="font-bebas text-white text-[56px] sm:text-7xl md:text-8xl lg:text-[120px] leading-[0.9] tracking-wide mb-5" data-id="element-846">
          Summer Training Schedule
        </h1>
        <p className="font-inter text-white/85 text-base md:text-xl max-w-2xl mx-auto leading-relaxed" data-id="element-847">
          Speed, strength, and athletic development for youth, middle school,
          and high school athletes. Ten weeks, three programs, real progress you
          can measure.
        </p>
      </div>
    </section>;
}
/* ---------- LOCATION BANNER ---------- */
function LocationBanner() {
  return <section className="bg-reach-red" data-id="element-848">
      <div className="max-w-container mx-auto px-4 md:px-8 py-4 md:py-5" data-id="element-849">
        <p className="font-inter text-white text-center text-xs md:text-sm uppercase tracking-[0.25em] font-semibold" data-id="element-850">
          Inside INPOWERiQ . 6051 Alma Rd . McKinney TX 75070 . 10 Week Season
        </p>
      </div>
    </section>;
}
/* ---------- INTRO SECTION ---------- */
function IntroSection() {
  return <section className="bg-white py-16 md:py-20" data-id="element-851">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center" data-id="element-852">
        <p className="font-inter text-reach-black text-lg md:text-xl leading-relaxed" data-id="element-853">
          Reach Performance now trains out of INPOWERiQ Performance Center, a
          24,000 square foot facility with full strength and conditioning
          equipment, indoor turf, and an on-site recovery zone.
        </p>
      </div>
    </section>;
}
/* ---------- PROGRAMS AND SCHEDULE ---------- */
const PROGRAMS = [{
  title: 'Advanced Performance',
  eyebrow: 'High School . Ages 14+',
  duration: '75 minute sessions',
  schedule: ['Mon and Wed 9:00 to 10:15 AM', 'Tue and Thu 6:00 to 7:15 PM', 'Friday 1:00 to 2:15 PM']
}, {
  title: 'Performance Prep',
  eyebrow: 'Middle School . Ages 11 to 13',
  duration: '60 minute sessions',
  schedule: ['Mon and Wed 10:30 to 11:30 AM', 'Tue and Thu 5:00 to 6:00 PM', 'Friday 2:30 to 3:30 PM']
}, {
  title: 'Foundations',
  eyebrow: 'Youth . Ages 8 to 10',
  duration: '60 minute sessions',
  schedule: ['Tuesday 4:00 to 5:00 PM', 'Thursday 4:00 to 5:00 PM']
}];
function ProgramsAndSchedule() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-854">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-855">
        <div className="text-center mb-14" data-id="element-856">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-857">
            Programs and Class Times
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-858">
            Choose Your Program
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-859">
          {PROGRAMS.map(program => <div key={program.title} className="bg-white rounded-[4px] p-8 border-b-4 border-transparent hover:border-reach-red transition-colors" data-id="element-860">
              <p className="font-inter text-reach-red text-xs uppercase tracking-[0.25em] font-semibold mb-3" data-id="element-861">
                {program.eyebrow}
              </p>
              <h3 className="font-bebas text-3xl md:text-4xl tracking-wide leading-none mb-4" data-id="element-862">
                {program.title}
              </h3>
              <div className="flex items-center gap-2 mb-6 text-sm font-inter text-reach-black/70" data-id="element-863">
                <Clock size={14} className="text-reach-red" data-id="element-864" />
                <span className="uppercase tracking-wider" data-id="element-865">
                  {program.duration}
                </span>
              </div>
              <div className="border-t border-black/10 pt-4" data-id="element-866">
                <p className="font-inter text-xs uppercase tracking-[0.25em] text-reach-black/60 mb-3" data-id="element-867">
                  Weekly Schedule
                </p>
                <ul className="space-y-2" data-id="element-868">
                  {program.schedule.map(slot => <li key={slot} className="font-inter text-sm text-reach-black/80" data-id="element-869">
                      {slot}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- WEEK AT A GLANCE ---------- */
function WeekAtAGlance() {
  const schedule = [{
    time: '9:00 to 10:15 AM',
    mon: 'ADVANCED 14+',
    tue: '',
    wed: 'ADVANCED 14+',
    thu: '',
    fri: ''
  }, {
    time: '10:30 to 11:30 AM',
    mon: 'PERF PREP 11 to 13',
    tue: '',
    wed: 'PERF PREP 11 to 13',
    thu: '',
    fri: ''
  }, {
    time: '1:00 to 2:15 PM',
    mon: '',
    tue: '',
    wed: '',
    thu: '',
    fri: 'ADVANCED 14+'
  }, {
    time: '2:30 to 3:30 PM',
    mon: '',
    tue: '',
    wed: '',
    thu: '',
    fri: 'PERF PREP 11 to 13'
  }, {
    time: '4:00 to 5:00 PM',
    mon: '',
    tue: 'FOUNDATIONS 8 to 10',
    wed: '',
    thu: 'FOUNDATIONS 8 to 10',
    fri: ''
  }, {
    time: '5:00 to 6:00 PM',
    mon: '',
    tue: 'PERF PREP 11 to 13',
    wed: '',
    thu: 'PERF PREP 11 to 13',
    fri: ''
  }, {
    time: '6:00 to 7:15 PM',
    mon: '',
    tue: 'ADVANCED 14+',
    wed: '',
    thu: 'ADVANCED 14+',
    fri: ''
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-870">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-871">
        <div className="text-center mb-12" data-id="element-872">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-873">
            The Week at a Glance
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-874">
            Full Schedule
          </h2>
        </div>

        <div className="overflow-x-auto" data-id="element-875">
          <table className="w-full min-w-[640px] border-collapse" data-id="element-876">
            <thead data-id="element-877">
              <tr className="bg-reach-black text-white" data-id="element-878">
                <th className="font-bebas text-lg tracking-wider uppercase text-left p-4 border-r border-white/10" data-id="element-879">
                  Time
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-880">
                  Monday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-881">
                  Tuesday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-882">
                  Wednesday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-883">
                  Thursday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4" data-id="element-884">
                  Friday
                </th>
              </tr>
            </thead>
            <tbody data-id="element-885">
              {schedule.map((row, i) => <tr key={row.time} className={i % 2 === 0 ? 'bg-reach-gray' : 'bg-white'} data-id="element-886">
                  <td className="font-inter text-sm font-semibold text-reach-black p-4 border-r border-black/5" data-id="element-887">
                    {row.time}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-888">
                    {row.mon}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-889">
                    {row.tue}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-890">
                    {row.wed}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-891">
                    {row.thu}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4" data-id="element-892">
                    {row.fri}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}
/* ---------- PERIODIZED PROGRAMMING ---------- */
function PeriodizedProgramming() {
  return <section className="bg-reach-black text-white py-20 md:py-28 relative overflow-hidden" data-id="element-893">
      <div className="absolute -right-40 top-1/4 w-[50%] h-1 bg-reach-red opacity-30 rotate-[6deg]" data-id="element-894" />
      <div className="absolute -right-40 top-[34%] w-[35%] h-1 bg-reach-red opacity-20 rotate-[6deg]" data-id="element-895" />

      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-896">
        <div className="text-center mb-12" data-id="element-897">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-898">
            What Your Athlete Trains
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none mb-4" data-id="element-899">
            Periodized Programming.
            <br data-id="element-900" />
            Every Day Has a Purpose.
          </h2>
          <p className="font-inter text-white/85 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-901">
            Speed plus strength plus recovery every session. Testing every 4
            weeks.
          </p>
        </div>

        <p className="font-inter text-white/85 text-base md:text-lg leading-relaxed max-w-3xl mx-auto text-center mb-12" data-id="element-902">
          Speed work and strength work are scheduled by day, not at random.
          Athletes work through a planned progression each week so the right
          qualities get trained at the right time.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto" data-id="element-903">
          <div className="bg-white/[0.04] border border-white/10 rounded-[4px] p-8" data-id="element-904">
            <h3 className="font-bebas text-2xl md:text-3xl tracking-wide mb-6 text-reach-red" data-id="element-905">
              Speed Focus by Day
            </h3>
            <ul className="space-y-3" data-id="element-906">
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-907">
                <span className="font-bebas text-lg tracking-wider" data-id="element-908">
                  Mon and Tue
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-909">
                  Acceleration
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-910">
                <span className="font-bebas text-lg tracking-wider" data-id="element-911">
                  Wed and Thu
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-912">
                  COD / Multidirectional
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-913">
                <span className="font-bebas text-lg tracking-wider" data-id="element-914">
                  Friday
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-915">
                  Max Velocity
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white/[0.04] border border-white/10 rounded-[4px] p-8" data-id="element-916">
            <h3 className="font-bebas text-2xl md:text-3xl tracking-wide mb-6 text-reach-red" data-id="element-917">
              Strength Focus by Day
            </h3>
            <ul className="space-y-3" data-id="element-918">
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-919">
                <span className="font-bebas text-lg tracking-wider" data-id="element-920">
                  Monday
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-921">
                  Lower Body
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-922">
                <span className="font-bebas text-lg tracking-wider" data-id="element-923">
                  Wednesday
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-924">
                  Upper Body
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-925">
                <span className="font-bebas text-lg tracking-wider" data-id="element-926">
                  Friday
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-927">
                  Full Body
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-928">
                <span className="font-bebas text-lg tracking-wider" data-id="element-929">
                  Tue and Thu
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-930">
                  Full Body
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- TESTING AND RECOVERY ---------- */
function TestingAndRecovery() {
  const testDates = [{
    label: 'Jun 1',
    sub: 'Baseline'
  }, {
    label: 'Jun 29',
    sub: 'Mid Summer'
  }, {
    label: 'Jul 27',
    sub: 'Final'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-931">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-932">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-933">
          {/* Performance Testing */}
          <div className="bg-reach-gray rounded-[4px] p-8 md:p-10 border-l-4 border-reach-red" data-id="element-934">
            <div className="flex items-center gap-3 mb-4" data-id="element-935">
              <Target size={24} className="text-reach-red" data-id="element-936" />
              <h3 className="font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-937">
                Performance Testing . Every 4 Weeks
              </h3>
            </div>
            <p className="font-inter text-reach-black text-base leading-relaxed mb-6" data-id="element-938">
              Three testing days across the summer. Same markers each time so
              progress is measured, not guessed at.
            </p>
            <div className="flex items-center justify-between gap-4 mb-6" data-id="element-939">
              {testDates.map(date => <div key={date.label} className="text-center" data-id="element-940">
                  <p className="font-bebas text-3xl md:text-4xl text-reach-red tracking-wide leading-none mb-1" data-id="element-941">
                    {date.label}
                  </p>
                  <p className="font-inter text-xs uppercase tracking-[0.2em] text-reach-black/70" data-id="element-942">
                    {date.sub}
                  </p>
                </div>)}
            </div>
            <p className="font-inter text-sm text-reach-black/70 leading-relaxed italic" data-id="element-943">
              We test 10 yard, 30 yard, vertical jump, and broad jump. These are
              foundational markers commonly used in high level performance
              programs.
            </p>
          </div>

          {/* Recovery */}
          <div className="bg-reach-gray rounded-[4px] p-8 md:p-10 border-l-4 border-reach-red" data-id="element-944">
            <div className="flex items-center gap-3 mb-4" data-id="element-945">
              <Calendar size={24} className="text-reach-red" data-id="element-946" />
              <h3 className="font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-947">
                Recovery Included
              </h3>
            </div>
            <p className="font-inter text-reach-black text-base leading-relaxed mb-6" data-id="element-948">
              Every membership includes access to INPOWERiQ on-site recovery
              zone after training. Athletes can cool down, recover, and come
              back ready for the next session.
            </p>
            <p className="font-inter text-reach-black text-base leading-relaxed" data-id="element-949">
              Recovery is part of how athletes get better, not an upgrade.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- MEMBERSHIP INCLUDES ---------- */
const INCLUDES = ['Access to the on-site recovery zone after every session.', 'Performance testing every 4 weeks across the summer.', 'Speed gates and jump mat testing for real progress data.', 'Periodized programming, never random workouts.', 'Capped small group training for individualized coaching.', 'Integrated speed and strength every session.'];
function MembershipIncludes() {
  return <section className="bg-reach-gray py-20 md:py-24" data-id="element-950">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-951">
        <div className="text-center mb-10" data-id="element-952">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-953">
            Every Membership Includes
          </p>
          <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none" data-id="element-954">
            What's Included
          </h2>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white rounded-[4px] p-6 md:p-8 border-l-4 border-reach-red" data-id="element-955">
          {INCLUDES.map(item => <li key={item} className="flex items-start gap-3" data-id="element-956">
              <div className="w-6 h-6 bg-reach-red rounded-sm flex items-center justify-center shrink-0 mt-0.5" data-id="element-957">
                <Check size={14} className="text-white" strokeWidth={3} data-id="element-958" />
              </div>
              <span className="font-inter text-reach-black text-base" data-id="element-959">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}
/* ---------- FINAL CTA ---------- */
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-960">
      <div className="max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-961">
        <h2 className="font-bebas text-white text-5xl md:text-7xl tracking-wide mb-10" data-id="element-962">
          Reserve Your Spot.
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-963">
          <Link to="/pricing" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm md:text-base hover:-translate-y-[3px]" data-id="element-964">
            Enroll Now
          </Link>
          <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-965">
            Book Free Consultation
          </Link>
        </div>
      </div>
    </section>;
}